(function($) {

	var $el = {
		gallery: $('.jq-product-gallery')
	};

	if ($el.gallery.length && productGallery.length) {

		window._pswpStack = window._pswpStack || [];

		window._pswpStack.push(function() {

			$el.gallery.on('click', openGallery);

		});

	}

	function openGallery(clickEvent) {

		clickEvent.preventDefault();

		$el.item = $(this);

		$el.pswp = $('.pswp');

		var galleryInstance = new PhotoSwipe($el.pswp[0], PhotoSwipeUI_Default, productGallery, {
			index: $el.item.data('product-gallery-index') || 0,
			loop: true,
			bgOpacity: 1,
			closeEl: true,
			captionEl: true,
			fullscreenEl: false,
			zoomEl: false,
			shareEl: false,
			counterEl: false,
			arrowEl: true,
			preloaderEl: true,
			barsSize: {
				top: 112,
				bottom: 112
			},
			// option to disable zoom below
			maxSpreadZoom: 1,
			getDoubleTapZoom: function(isMouseClick, item) {
				return item.initialZoomLevel;
			},
			pinchToClose: false
		});

		if (galleryInstance.options.maxSpreadZoom == 1) {

			$el.pswp.addClass('is-disable-zoom');

		}

		$el.paginations = $('.pswp__paginations', $el.pswp);

		if ('thumb' in productGallery[0]) {

			if ($el.paginations.length == 0) {

				$el.paginations = $('<div class="pswp__paginations"></div>');

				$el.pswp
					.find('.pswp__ui')
					.append($el.paginations);

			} else {

				$el.paginations.empty();

				delete $el.thumbnails;

			}

			productGallery.forEach(function(productImage) {

				var $thumbnail = $('<button type="button" class="pswp__thumbnail"' + ('thumb' in productImage ? ' style="background-image: url(' + productImage.thumb + ')"' : '') + '></button>');

				if (!('thumbnails' in $el)) {

					$el.thumbnails = $thumbnail;

				} else {

					$el.thumbnails = $el.thumbnails.add($thumbnail);

				}

			});

			$el.paginations.append($el.thumbnails);

			galleryInstance.listen('afterChange', function() {

				$el.thumbnails.removeClass('is-active');

				var $thumbnail = $el.thumbnails.eq(galleryInstance.getCurrentIndex());

				$thumbnail.addClass('is-active');

				var thumbnailOffset = $thumbnail.offset().left;

				var thumbnailWidth = $thumbnail.width();

				var paginationsCurrentScroll = $el.paginations.scrollLeft();

				var paginationsWidth = $el.paginations.width();

				if (thumbnailOffset < paginationsCurrentScroll ||
					thumbnailOffset + thumbnailWidth > paginationsWidth) {

					$el.paginations.scrollLeft(
						paginationsCurrentScroll +
						thumbnailOffset -
						thumbnailWidth / 2
					);

				}


			});

		} else {

			if ($el.paginations != 0) $el.paginations.remove();

		}

		$el.thumbnails.on('click', function() {

			galleryInstance.goTo($(this).index());

		});

		// create variable that will store real size of viewport
		var realViewportWidth,
			useLargeImages = false,
			firstResize = true,
			imageSrcWillChange;

		// beforeResize event fires each time size of gallery viewport updates
		galleryInstance.listen('beforeResize', function() {

			// gallery.viewportSize.x - width of PhotoSwipe viewport
			// gallery.viewportSize.y - height of PhotoSwipe viewport
			// window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
			//                          1 (regular display), 2 (@2x, retina) ...


			// calculate real pixels when size changes
			realViewportWidth = galleryInstance.viewportSize.x * window.devicePixelRatio;

			// Code below is needed if you want image to switch dynamically on window.resize

			// Find out if current images need to be changed
			if (useLargeImages && realViewportWidth < 1000) {
				useLargeImages = false;
				imageSrcWillChange = true;
			} else if (!useLargeImages && realViewportWidth >= 1000) {
				useLargeImages = true;
				imageSrcWillChange = true;
			}

			// Invalidate items only when source is changed and when it's not the first update
			if (imageSrcWillChange && !firstResize) {
				// invalidateCurrItems sets a flag on slides that are in DOM,
				// which will force update of content (image) on window.resize.
				galleryInstance.invalidateCurrItems();
			}

			if (firstResize) {
				firstResize = false;
			}

			imageSrcWillChange = false;

		});


		// gettingData event fires each time PhotoSwipe retrieves image source & size
		galleryInstance.listen('gettingData', function(index, item) {

			// Set image source & size based on real viewport width
			if (useLargeImages) {
				item.src = item.originalImage.src;
				item.w = item.originalImage.w;
				item.h = item.originalImage.h;
			} else {
				item.src = item.mediumImage.src;
				item.w = item.mediumImage.w;
				item.h = item.mediumImage.h;
			}

		});

		galleryInstance.listen('close', function() {

			$el.pswp.removeClass('is-disable-zoom');

			if ($el.paginations != 0) $el.paginations.remove();

			if ('splideInstances' in window) {

				$el.syncSlider = $el.item.parents('.jq-slider');

				window.splideInstances.forEach(function(splideInstance) {

					if (splideInstance.root == $el.syncSlider[0]) {

						splideInstance.go(galleryInstance.getCurrentIndex());

					}

				});

			}

		});

		// Note that init() method is called after gettingData event is bound
		galleryInstance.init();

	}

})(jQuery);
